import { useContext, useEffect, useMemo, useState } from "react";
import KrFormContext, { EndangeredAreaRasters, KrEndangeredAreaFormTypes, krFormTypes, KrLandslideFormTypes, LandslideRasters, NavHeadingsKROEnum } from "../../../../contexts/krFormContext";
import { RastersAttributes } from "../../../../contexts/poFormContext";
import { RasterType } from "../types/krFormView";
import UploadRasters from "./shared/uploadRasters/uploadRasters";
import ConfirmModal from "../../../../components/modalWindow/confirmModal";
import SelectInput from "../../../../components/shared/selectInput/selectInput";
import { Option } from "../../../../components/shared/selectInput/types/selectInputProps";
import { styleFormFieldHalf } from "../../../../components/shared/stylization";
import { createConfigValidation, validation } from "../../../../helpers/validation/validation";
import { getFieldRef, getItemRef, renderSectionCommentBtn } from "../../../../helpers/form";
import { ObjectType, PatternType } from "../../../../contexts/types/card";
import { KROFieldDict, KRTZFieldDict } from "../../shared/commentsSidebar/fieldDict";

const OPTIONS_TYPE: Option[] = [{
    name: "Mapa", value: RasterType.Map
},
{
    name: "Szkic", value: RasterType.Sketch
}];
const ACCEPT_FILES = [
    "image/jpg",
    "image/jpeg"
];
const maxFileSize: any = 1048576;  // ~ 1 MB
const maxFileDimensions: any = 2000;
const maxFileNumberForUpload: any = 30;

const MapSection = (props: {
    isLandslide: boolean,
    getMapForNavScroll?: Function,
    objectType?: ObjectType,
    getMapForComment?: Function,
    editMode?: boolean,
    setNewCommentFieldDetails?: Function,
    setCommentsFilter?: any,
    markedFieldForCommentFiltering?: string,
    version: number
}) => {
    const { krForm, setkrForm } = useContext(KrFormContext);
    const [fileRow, setFileRow] = useState<RastersAttributes>();
    const [confirmation, setConfirmation] = useState<boolean>(false);
    const [infoText, setInfoText] = useState("");
    const [tableError, setTableError] = useState<boolean>(false);
    const [tableErrorMsg, setTableErrorMsg] = useState<string>("");
    const [focusTable, setFocusTable] = useState<boolean>(false);

    const refocus = () => {
        setFocusTable(true);
    }
    const [rasterType, setRasterType] = useState(OPTIONS_TYPE[0]);

    const refreshValidation = (values: any, name: string) => {
        const currValidation = createConfigValidation(name, false);
        const currValidationMsg = validation(currValidation, values);
        if (currValidationMsg) {
            setTableError(true);
            setTableErrorMsg(currValidationMsg);
        } else {
            setTableError(false);
            setTableErrorMsg('');
        }
    }

    // Validation
    useEffect(() => {
        if (krForm.config?.check && !krForm.config.isValid) {
            const currValidation = createConfigValidation("rastersElements", false);
            if (props.isLandslide) {
                var data = (krForm as KrLandslideFormTypes).landslideRasters?.filter((raster: any) => {
                    return (raster.details.rodzaj === "mapa_u" || raster.details.rodzaj === "szkic" || raster.details.rodzaj === "mapa_a")
                })
                const errorMsg = validation(currValidation, data);
                if (errorMsg !== '') {
                    setTableError(true);
                    setTableErrorMsg(errorMsg);
                }
            } else {
                var dataEndangered = (krForm as KrEndangeredAreaFormTypes).endangeredAreaRasters?.filter((raster: any) => {
                    return (raster.details.rodzaj === "mapa_u" || raster.details.rodzaj === "szkic" || raster.details.rodzaj === "mapa_a")
                })
                const errorMsg = validation(currValidation, dataEndangered);
                if (errorMsg !== '') {
                    setTableError(true);
                    setTableErrorMsg(errorMsg);
                }
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm.config?.check])

    const onInfoChangeHandler = (newKrForm: krFormTypes) => {
        if (infoText !== null) {
            setInfoText("");
        }
        if (props.isLandslide) {
            refreshValidation((newKrForm as KrLandslideFormTypes)?.landslideRasters, "rastersElements");
        } else {
            refreshValidation((newKrForm as KrEndangeredAreaFormTypes)?.endangeredAreaRasters, "rastersElements");
        }
    }

    const cancel = () => {
        setConfirmation(false);
    }

    // Confirm delete image
    const confirm = () => {
        setConfirmation(false);
        deleteFile(fileRow);
    }

    const deleteFile = (row: any) => {
        if (krForm !== null) {
            if (props.isLandslide) {
                var currOsRasters = _removeFile(row, (krForm as KrLandslideFormTypes).landslideRasters);
                setkrForm({...krForm, landslideRasters: currOsRasters});
                refreshValidation(currOsRasters, "rastersElements");
            } else {
                var currTzRasters = _removeFile(row, (krForm as KrEndangeredAreaFormTypes).endangeredAreaRasters);
                setkrForm({...krForm, endangeredAreaRasters: currTzRasters});
                refreshValidation(currTzRasters, "rastersElements");
            }
        }
    }

    const _removeFile = (row: any, rasters: LandslideRasters[] | EndangeredAreaRasters[] | undefined) => {
        return rasters?.filter((item: any) => {
            return item.details.globalid !== row.globalid;
        });
    }

    const confirmQuestion = useMemo(() => {
        return `Czy na pewno chcesz usunąć plik ${fileRow?.pliK_NAZWA}?`;
    }, [fileRow?.pliK_NAZWA])

    const sectionHeading = useMemo(() => {
        return props.version === PatternType.P2007 ? "14. Szkic (mapa) osuwiska" : "14. Mapa";
    }, [props.version])

    const renderCommentBtn = () => {
        if (props.isLandslide) return renderSectionCommentBtn(props.markedFieldForCommentFiltering === KROFieldDict.mapa_sekcja, false, sectionHeading, props.setNewCommentFieldDetails!, KROFieldDict.mapa_sekcja);
        else return renderSectionCommentBtn(props.markedFieldForCommentFiltering === KRTZFieldDict.lok_mapaTerenu_podsekcja, false, "Mapa terenu", props.setNewCommentFieldDetails!, KRTZFieldDict.lok_mapaTerenu_podsekcja)
    }

    return (
        <>
            <div ref={(node: any) => { getFieldRef(node, KROFieldDict.mapa_sekcja, props.getMapForComment!) }} style={{ width: '100%' }}></div>
            <div ref={(node) => { if (props.objectType === ObjectType.KRO) getItemRef(node, NavHeadingsKROEnum.MapSection, props.getMapForNavScroll!) }} style={{ width: "100%" }}>
                {props.isLandslide &&
                    <h2 style={{ width: '100%' }}
                        onClick={() => { if (props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.mapa_sekcja); }}
                    >{sectionHeading}</h2>
                }
                {!props.editMode && renderCommentBtn()}
                {props.editMode &&
                    <SelectInput placeHolder="Typ pliku" style={styleFormFieldHalf} label="Typ pliku"
                        hasInputTags={false} options={OPTIONS_TYPE} onlySingleTag={false}
                        selectedSingleOption={rasterType} onChange={setRasterType} disabled={!props.editMode} />
                }
                <UploadRasters
                    maxFileSize={maxFileSize}
                    maxFileDimensions={maxFileDimensions}
                    maxFileNumberForUpload={maxFileNumberForUpload}
                    rasterType={rasterType.value as RasterType}
                    acceptedFiles={ACCEPT_FILES}
                    acceptedFilesForSnackbar=".jpg lub .jpeg"
                    dropzoneText={<>
                        Przeciągnij i upuść plik w formacie .jpg/.jpeg, aby dodać go do formularza.
                        <br></br>Pliki powyżej 1MB lub długość boku 2000 pix będą skalowane do odpowiedniego rozmiaru.
                        <br></br>Jednocześnie wgrać można maksymalnie 30 plików.
                    </>}
                    isLandslide={props.isLandslide}
                    infoSectionChangeHandler={onInfoChangeHandler}
                    clickRowHandler={setFileRow}
                    confirmationToggle={setConfirmation}
                    foldoutInputValidation={{
                        minCharacters: {
                            minNumberOfCharacters: 10,
                            errorMsg: "Należy wpisać minimum 10 znaków"
                        }
                    }}
                    headers={{
                        pliK_NAZWA: "Nazwa pliku",
                        nameRodzaj: "Rodzaj pliku",
                        opis: "Opis",
                        imagePreview: ""
                    }}
                    isMaps
                    tableError={tableError}
                    tableErrorMsg={tableErrorMsg}
                    refreshValidation={refreshValidation}
                    getMapForComment={props.getMapForComment}
                    editMode={props.editMode}
                    setNewCommentFieldDetails={props.setNewCommentFieldDetails}
                    KRFieldDictForRows={props.isLandslide ? KROFieldDict.mapa_mapa : KRTZFieldDict.lok_mapaTerenu}
                    fieldFormNameForRows={props.isLandslide ? "Mapa" : "Mapa terenu"}
                    setCommentsFilter={props.setCommentsFilter}
                    markedFieldForCommentFiltering={props.markedFieldForCommentFiltering}
                    refocus={focusTable}
                    setRefocusTable={setFocusTable}
                />
            </div>
            {confirmation && <ConfirmModal
                width="660px"
                height="auto"
                confirmTitle="Tak, usuń plik"
                onConfirm={confirm}
                cancelTitle="Anuluj"
                onCancel={cancel}
                question={confirmQuestion}
                refocus={refocus} />}
        </>
    )
}

export default MapSection;